import React, { useState, useEffect, useRef } from 'react'
import { useDetectOutsideClick } from "./useDetectOutsideClick";
import Settings from './Settings'

import Transparent from '../images/sprite/transparent.gif'
// import Refresh from '../images/refresh80-livesports.gif'
//import Login from '../images/newver.png'
import 'react-toastify/dist/ReactToastify.css'
import Content from './Content'
import Cookies from 'universal-cookie';
import { toast } from 'react-toastify'
import { suid } from 'rand-token';
import axios from 'axios';
import { Link, BrowserRouter as Router, Route, Switch, useLocation } from "react-router-dom";
import img1 from '../images/headerlogo.png'
import Changepassword from './Changepassword';
import Myprofile from './Myprofile';
import Balanceoverview from './Balanceoverview';
import AccountStatement from './AccountStatement';
import Mybets from './Mybets';
import Bethistory from './Bethistory';
import ProfitLoss from './ProfitLoss';
import CasinoReport from './CasinoReport';
import ActivityLog from './ActivityLog';
import FirsttimeLogin from './FirsttimeLogin'
import moment from 'moment';
import CaptchaGenerator from '../component/captcha-generator/captcha-generator';

// react query
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { queryClient } from '../serives/react-query/provider';
import { refreshBalanceApiRq, getGameBalanceApiRq, enterCasinoTransactionApiRq } from '../serives/react-query/api-actions';


require('moment-timezone');



const cookies = new Cookies();

window.flag = 0;

var tt;
toast.configure()


export function detectMobile() {
  var check = false;
  (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
  return check;
};

export default function Desktopindex(props) {
  const location = useLocation();

  var eventId = null;
  var marketId = null;
  var eventT = 1;
  var isMobil = detectMobile();


  if (isMobil && !(props.match.params.eventType === 'exchange' && props.match.params.subType === 'play' && props.match.params.belowType === 'myprofile' || props.match.params.eventType === 'exchange' && props.match.params.subType === 'play' && props.match.params.belowType === 'balance' || props.match.params.eventType === 'exchange' && props.match.params.subType === 'play' && props.match.params.belowType === 'AccountStatement' || props.match.params.eventType === 'exchange' && props.match.params.subType === 'play' && props.match.params.belowType === 'mybets' || props.match.params.eventType === 'exchange' && props.match.params.subType === 'play' && props.match.params.belowType === 'bethistory' || props.match.params.eventType === 'exchange' && props.match.params.subType === 'play' && props.match.params.belowType === 'ProfitLoss' || props.match.params.eventType === 'exchange' && props.match.params.subType === 'play' && props.match.params.belowType === 'casinoProfitLoss' || props.match.params.eventType === 'exchange' && props.match.params.subType === 'play' && props.match.params.belowType === 'activitylog' || props.match.params.eventType === 'exchange' && props.match.params.subType === 'play' && props.match.params.belowType === 'result' || props.match.params.eventType === 'exchange' && props.match.params.subType === 'play' && props.match.params.belowType === 'kycdesk')) {
    window.location.reload();
  }
  if (props.match.params.eventT === '4' || props.match.params.eventT === '1' || props.match.params.eventT === '2' || props.match.params.eventT === '2378962' || props.match.params.eventT === '7522') {
    eventId = props.match.params.eventId;
    marketId = props.match.params.marketId;
    eventT = 0;
  }
  if (props.match.params.eventType === 'bing' && props.match.params.subType === 'win' && props.match.params.belowType === 'homepage.jsp') {
    eventT = 1;
  }
  else if (props.match.params.eventType === 'bing' && props.match.params.subType === 'play' && props.match.params.belowType === 'inplay') {
    eventT = 2;
  }
  else if (props.match.params.eventType === 'bing' && props.match.params.subType === 'play' && props.match.params.belowType === 'multimarket') {
    eventT = 3;
  }
  else if (props.match.params.eventType === 'bing' && props.match.params.subType === 'play' && props.match.params.belowType === 'cricket') {
    eventT = 4;
  }
  else if (props.match.params.eventType === 'bing' && props.match.params.subType === 'play' && props.match.params.belowType === 'soccer') {
    eventT = 5;
  }
  else if (props.match.params.eventType === 'bing' && props.match.params.subType === 'play' && props.match.params.belowType === 'tennis') {
    eventT = 6;
  }


  else if (props.match.params.eventType === 'exchange' && props.match.params.subType === 'play' && props.match.params.belowType === 'myprofile') {
    eventT = 7;

  }
  else if (props.match.params.eventType === 'exchange' && props.match.params.subType === 'play' && props.match.params.belowType === 'balance') {
    eventT = 8;
  }
  else if (props.match.params.eventType === 'exchange' && props.match.params.subType === 'play' && props.match.params.belowType === 'AccountStatement') {
    eventT = 9;
  }
  else if (props.match.params.eventType === 'exchange' && props.match.params.subType === 'play' && props.match.params.belowType === 'mybets') {
    eventT = 10;
  }
  else if (props.match.params.eventType === 'exchange' && props.match.params.subType === 'play' && props.match.params.belowType === 'bethistory') {
    eventT = 11;
  }
  else if (props.match.params.eventType === 'exchange' && props.match.params.subType === 'play' && props.match.params.belowType === 'ProfitLoss') {
    eventT = 12;
  }
  else if (props.match.params.eventType === 'exchange' && props.match.params.subType === 'play' && props.match.params.belowType === 'activitylog') {
    eventT = 13;
  }
  else if (props.match.params.eventType === 'exchange' && props.match.params.subType === 'play' && props.match.params.belowType === 'IplWinner') {
    eventT = 30;
  }
  else if (props.match.params.eventType === 'exchange' && props.match.params.subType === 'play' && props.match.params.belowType === 'election') {
    eventT = 31;
  }
  else if (props.match.params.eventType === 'exchange' && props.match.params.subType === 'play' && props.match.params.belowType === 'basketball') {
    eventT = 17;
  }
  else if (props.match.params.eventType === 'exchange' && props.match.params.subType === 'play' && props.match.params.belowType === 'casinoProfitLoss') {
    eventT = 25;
  }



  const dropdownRef = useRef(null);
  const dropdownRef1 = useRef(null);
  const [open, setOpen] = useState(false);
  const [isLoggedIn, setLoggedIn] = useState(false);
  const [isError, setIsError] = useState(false);
  const [userid, setId] = useState("");
  const [password, setPassword] = useState("");
  const [captchaSuccess, setCaptcha] = useState(false);
  const [loading, setloading] = useState(false);
  const [tabMenu, setTabMenu] = useState(eventT);
  const [balance, setBalance] = useState(0);
  const [exposure, setExposure] = useState(0);
  const [oneClick, setOneclick] = useState(false);
  const [countCricket, setCountCricket] = useState(0);
  const [countSoccer, setCountSoccer] = useState(0);
  const [countTennis, setCountTennis] = useState(0);
  const [countBasketball, setCountBasketball] = useState(0);
  const [ShowPassModel, setShowPassModel] = useState(false);
  const [firstname, setfirstname] = useState("");
  const [lastname, setlastname] = useState("");
  //captcha
  const [renderCaptcha, setRenderCaptcha] = useState(true);
  const [captchaCode, setCaptchaCode] = useState('');
  const [captchaCodePopup, setCaptchaCodePopup] = useState('');

  const [isTransferFiald, setIsTransferFiald] = useState({ msg: '', isFaild: false });


  const [firstlogin, setfirstlogin] = useState(0)

  const [isActive, setIsActive] = useDetectOutsideClick(dropdownRef1, false);
  //const ddhandleClick = () => setIsActive(!isActive);

  const [dropdownopen, setdropdownopen] = useDetectOutsideClick(dropdownRef, false);
  const dsClick = () => {
    if (window.flag === 0) {
      setdropdownopen(!dropdownopen);
    }
  }

  function changecount(cri, socc, tenn, basket) {

    setCountCricket(cri);
    setCountSoccer(socc);
    setCountTennis(tenn);
    setCountBasketball(basket)
  }


  const handlepassmodel = () => {
    setShowPassModel(true)
  }
  const handleClosepassmodel = () => {
    setShowPassModel(false)
  }

  const updateBalance = (val1, val2) => {
    setBalance(val1);
    setExposure(val2);

  }



  useEffect(() => {
    setTabMenu(eventT);
  });


  useEffect(() => {


    rerenderCaptchaCode();

    if (cookies.get('oneclick') == null) {
      cookies.set('oneclick', 0, { path: '/' });
    }

    axios.all([
      axios.get('https://luckybdt.live/clientapi/cricket'),
      axios.get('https://luckybdt.live/clientapi/soccer'),
      axios.get('https://luckybdt.live/clientapi/tennis'),
      // axios.get('https://luckybdt.live/clientapi/Basketball')

    ])
      .then(axios.spread((obj1, obj2, obj3, obj4) => {
        var count1 = 0;
        var count2 = 0;
        var count3 = 0;
        var count4 = 0;
        obj1.data.map(item => {
          item.marketStartTime = moment.tz(item.marketStartTime, 'YYYY-MM-DD HH:mm:ss', 'Asia/Kolkata').local().format('YYYY-MM-DD HH:mm:ss');
          return item;
        })

        obj2.data.map(item => {
          item.marketStartTime = moment.tz(item.marketStartTime, 'YYYY-MM-DD HH:mm:ss', 'Asia/Kolkata').local().format('YYYY-MM-DD HH:mm:ss');
          return item;
        })
        obj3.data.map(item => {
          item.marketStartTime = moment.tz(item.marketStartTime, 'YYYY-MM-DD HH:mm:ss', 'Asia/Kolkata').local().format('YYYY-MM-DD HH:mm:ss');
          return item;
        })
        obj4.data.map(item => {
          item.marketStartTime = moment.tz(item.marketStartTime, 'YYYY-MM-DD HH:mm:ss', 'Asia/Kolkata').local().format('YYYY-MM-DD HH:mm:ss');
          return item;
        })

        obj1.data.map((item) => {
          if (moment() >= moment(item.marketStartTime)) {
            count1 = count1 + 1;
          }
        });
        obj2.data.map((item) => {
          if (moment() >= moment(item.marketStartTime)) {
            count2 = count2 + 1;
          }
        });
        obj3.data.map((item) => {
          if (moment() >= moment(item.marketStartTime)) {
            count3 = count3 + 1;
          }
        });

        obj4.data.map((item) => {
          if (moment() >= moment(item.marketStartTime)) {
            count4 = count4 + 1;
          }
        });


        changecount(count1, count2, count3, count4);


      }));

  }, []);



  const rerenderCaptchaCode = () => {
    setRenderCaptcha(false);
    setTimeout(() => {
      setRenderCaptcha(true);
    }, 200);
  }

  const popupCaptchaReder = () => {
    return renderCaptcha ? (
      <CaptchaGenerator textColor="black"
        captchaCode={(code) => setCaptchaCodePopup(`${code}`)}
      />
    ) : null
  }


  function validateCaptcha(event) {
    const captchaValue = event.target.value;
    if ((open && captchaValue === captchaCodePopup) || (captchaValue === captchaCode)) {
      setCaptcha(true);
    } else {
      setCaptcha(false);
    }

  }

  const handleOpen = () => {
    if (!isLoggedIn) {
      setOpen(true);
      setTimeout(() => {
        rerenderCaptchaCode();
      }, 300)
    }
  };



  const handleOnclick = () => {
    if (!isLoggedIn) {
      handleOpen();
    }
    else {
      if (oneClick) {
        cookies.set('oneclick', 0, { path: '/' });
      }
      else if (!oneClick) {
        cookies.set('oneclick', 1, { path: '/' });
      }
      setOneclick(!oneClick)
    }
  };
  const handleLivestrem = () => {
    if (!isLoggedIn) {
      handleOpen();

    }
    else {

    }
  };
  const handlesetting = () => {
    if (!isLoggedIn) {
      handleOpen();

    }
    else {
      if (window.flag === 0) {
        setIsActive(!isActive);
      }

    }
  };


  const handleClose = () => {
    setOpen(false);
    setTimeout(() => {
      rerenderCaptchaCode();

    }, 300)
  };



  const handleLogin = () => {


    if (userid === '') {

      rerenderCaptchaCode();
      toast.warn('Username can not be blank!', { position: toast.POSITION.TOP_CENTER })
      return;
    }
    if (password === '') {
      rerenderCaptchaCode();
      toast.warn('Password can not be blank!', { position: toast.POSITION.TOP_CENTER })
      return;
    }

    if (!captchaSuccess) {

      rerenderCaptchaCode();
      toast.warn('Captcha is not valid!', { position: toast.POSITION.TOP_CENTER })
      return;
    }

    var demoid1 = 'demo01';
    //var demoid2  = 'demo02'
    var token = suid(16);
    if (userid.toUpperCase() === demoid1.toUpperCase()) {
      token = '123456789';
    }
    tt = token;

    cookies.set('id', userid, { path: '/' });
    cookies.set('token', token, { path: '/' });

    // console.log(token);
    axios.post('https://luckybdt.live/clientapi/userlogin', {
      id: userid,
      password: password,
      token: token
    })
      .then(result => {

        if (result.status === 201) {

          setfirstlogin(1);

        }
        else if (result.status === 202) {

          setfirstlogin(2);

        }

        else if (result.status === 200) {
          window.location.reload();

          /* setLoggedIn(true);
           setCaptcha(false);

           axios.post('https://luckybdt.live/clientapi/refresh',{
              id:userid,
              token:token
             })
          .then(result => {
            if(result.status === 210){

              setLoggedIn(true);

              setBalance(result.data[0].val - Math.abs(result.data[1].val));
              if(result.data[1].val){
                setExposure(Math.abs(result.data[1].val));
               }
               else{
                 setExposure(0);
                 }
            }

            if(result.status === 220){
              console.log('refresh unsucessful');

             }
           }

          ).catch(e => {
           setIsError(true);
         }); */

        }
        else if (result.status === 205) {
          setCaptcha(false);
          toast.warn('User Blocked!', { position: toast.POSITION.TOP_CENTER })
          rerenderCaptchaCode();
        }
        else {
          setCaptcha(false);
          toast.warn('Username or password incorrect!', { position: toast.POSITION.TOP_CENTER })
          rerenderCaptchaCode();

        }
      }

      ).catch(e => {
        setIsError(true);
      });



  };

  const handleLogout = () => {
    cookies.remove('id', { path: '/' });
    // cookies.remove('token',{ path: '/' });
    cookies.remove('oneclick', { path: '/' });

  }

  const changeTab = () => {
    setTabMenu(0);
  }

  // refresh balance rq
  const getBlanceStatus = queryClient.getQueryData({ queryKey: ['refreshBalanceStatus'] });
  const { data, status } = getBlanceStatus ? getBlanceStatus : {};
  const pendingBalance = data?.pendingBalance;

  const utoken = cookies.get('token');
  const user = cookies.get('id');

  const refreshBalanceApiAction = useMutation({
    mutationFn: refreshBalanceApiRq,

    onSuccess: rsp => {
      const { data, status } = rsp;
      if (status === 210) {
        setId(user);
        tt = utoken;
        setLoggedIn(true);
        const mainBalance = data.mainBalance - Math.abs(data.exposureBalance);

        if (mainBalance) {
          setBalance(mainBalance)
        }
        if (data.exposureBalance) {
          setExposure(Math.abs(data.exposureBalance))
        }
      } else {
        setLoggedIn(false);
      }
      queryClient.setQueryData(['refreshBalanceStatus'], rsp);

    }
  });

  const handleRefresh = () => {
    refreshBalanceApiAction.mutate({ id: user, token: utoken });
  }
  useEffect(() => {
    setloading(true);
    setTimeout(() => { setloading(false); }, 1000);
    handleRefresh();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);



  // get blance from provider
  const enterCasinoTransactionApiAction = useMutation({
    mutationFn: enterCasinoTransactionApiRq,
    onSuccess: rsp => {
      handleRefresh();
      if (rsp.data.status === false) {
        setIsTransferFiald({ msg: rsp.data.message, isFaild: true });
      }
    }
  });

  const getGameBalanceApiAction = useMutation({
    mutationFn: getGameBalanceApiRq,
    onSuccess: ({ data, status }) => {
      const gameBalance = data.data.balance;
      const { providercode, member } = pendingBalance;

      if (data && status == 200 && gameBalance > 0) {
        // transfer ammount to ac
        enterCasinoTransactionApiAction.mutate({
          username: member,
          transferType: 'w',
          providercode,
          amount: gameBalance,
          token: utoken,
        })
      }

    }
  });


  useEffect(() => {
    if (status === 210 && pendingBalance && pendingBalance?.type == 0) {
      const { providercode, member } = pendingBalance;
      if (isTransferFiald.isFaild === false) {
        getGameBalanceApiAction.mutate({
          providercode,
          username: member
        })
      }

    }
  }, [getBlanceStatus]);


  // loading state

  useEffect(() => {
    if (getGameBalanceApiAction.isLoading || enterCasinoTransactionApiAction.isLoading || refreshBalanceApiAction.isLoading) {
      setloading(true);
    } else {
      setloading(false);
    }
  }, [refreshBalanceApiAction, enterCasinoTransactionApiAction, getGameBalanceApiAction])


  return (

    <React.Fragment>
      {isLoggedIn === true && loading === true && (
        <div style={{ zIndex: 1000, backgroundColor: 'transparent', height: '100vh', width: '100%', transform: 'translate(0, 0)', position: 'absolute', top: 0 }} class="loading-overlay">
          <div class="loading-wrap" style={{ display: " flex", height: '16rem', width: '22rem' }}>
            <div class="loading" style={{ width: '72px' }}>
              <div></div>
              <div></div>
            </div>
            <p style={{ fontSize: '2rem' }}>Loading...</p>
          </div>
        </div>
      )}
      {firstlogin == 0 && (
        <React.Fragment>

          {ShowPassModel === true &&
            <Changepassword setLoggedIn={setLoggedIn} userid={userid} utoken={tt} handleClosepassmodel={handleClosepassmodel} />
          }

          {open === true && isLoggedIn === false && (
            <>
              <div id="loginBox" className="overlay">
                <div className="dialog-wrap-w login-pg-go">
                  <div className="kv" style={{ width: '250px', height: '100%', borderRadius: '8px 0 0 8px' }}>
                    {/* <h1 style={{marginLeft: '-143px',marginTop:'80px'}}>
          <img src={Login}  alt="logo" style={{height: 'auto', width: '480px'}}/>
          </h1> */}
                    <img class="logo-dg" src={img1} alt="login-icon" />
                  </div>

                  <dl className="login-box-content">
                    <dt >Please login to continue</dt>
                    <dd ><input value={userid} onChange={(e) => { setId(e.target.value) }} id="loginBoxLoginName" type="text" placeholder="Username" /></dd>
                    <dd ><input value={password} onChange={(e) => { setPassword(e.target.value) }} id="loginBoxPassword" type="password" placeholder="Password" /></dd>
                    <dd className="valid-code">
                      <input onChange={(e) => { validateCaptcha(e) }} id="loginBoxValidCode" type="text" placeholder="captcha Code" maxLength="4" />

                      <div id="popupcaptcha" style={{ position: 'absolute', right: '9px', width: '44px', top: '9px' }}>
                        {popupCaptchaReder()}
                      </div>
                    </dd>


                    <dd >
                      <a onClick={handleLogin} id="loginBoxLoginBtn" className="btn-send">Login<img className="icon-login" src={Transparent} alt="login-icon" /></a></dd>
                    <dd id="loginBoxErrorMsg" className="error"></dd>
                  </dl>
                  <a id="close" style={{ cursor: ' pointer', position: 'absolute' }} onClick={handleClose} className="close">.</a>
                </div>
              </div>
            </>
          )}

          <div className="top">

            <div className="header main-content">

              <h1 _ngcontent-lst-c69="" ><a href="/" style={{ width: '105px', marginTop: '11px', height: '58px', marginLeft: "18.2px", backgroundRepeat: 'no-repeat', backgroundSize: "contain" }}>The bajie365</a>
              </h1>


              {tabMenu !== 7 && tabMenu !== 8 && tabMenu !== 9 && tabMenu !== 10 && tabMenu !== 11 && tabMenu !== 12 && tabMenu !== 13 && tabMenu !== 25 &&
                <div id="searchWrap" className="searchbar-header">
                  <div>

                    <input id="searchInput" className="main-input-search" type="text" placeholder="Search Events" />

                  </div>
                </div>}


              {isLoggedIn === false && <ul className="login-clientform" >
                <li className="user error">
                  <label htmlFor="loginName" style={{ color: '#212121' }}></label>
                  <input id="loginName" value={userid} onChange={(e) => { setId(e.target.value) }} type="text" placeholder="Username" />


                </li>

                <li >
                  <label htmlFor="password" style={{ color: '#212121' }}></label>
                  <input value={password} onChange={(e) => { setPassword(e.target.value) }} id="password" type="password" placeholder="Password" />


                </li>

                <li className="valid-code">
                  <label htmlFor="validCode" style={{ color: '#212121' }}></label>
                  <input onChange={(e) => { validateCaptcha(e) }} id="validCode" type="text" placeholder="Captcha" maxLength="4" />

                  <div id="captcha" style={{ position: 'absolute', bottom: '15px', right: '9px', width: '40px', height: '13px', top: '5px' }}>
                    {renderCaptcha && (
                      <CaptchaGenerator
                        textColor="black"
                        captchaCode={(code) => setCaptchaCode(`${code}`)}
                      />
                    )}
                  </div>
                </li>
                <li ><input id="valid" name="valid" type="hidden" value="1af3fcd7-a5d3-4b01-876e-d336fb343a85" /></li>
                <li >
                  <a onClick={handleLogin} id="loginBtn" className="btn-login" >Login
                    <img className="icon-login" src={Transparent} alt="1548051109718" />
                  </a>
                </li>
                <li ><a class="btn-signup">Sign up</a></li>

              </ul>}

              {isLoggedIn === true && <ul className="account-wrap">

                {/* Start */}
                <li class="main-wallet" style={{ background: "#2a1f3a" }}>
                  <a id="multiWallet" class="a-wallet">
                    {loading === false && <ul id="accountCredit" style={{ display: 'flex', color: 'rgb(255 190 24)' }}>
                      <li ><span>Main Balance</span> <span id="betCredit">PBU {balance.toFixed(2)}</span></li>
                      <li ><span>Exposure</span> <span id="totalExposure" className={`${exposure > 0 ? "red" : ""}`}>{exposure > 0 ? '(' + exposure.toFixed(2) + ')' : exposure.toFixed(2)}</span></li>

                    </ul>
                    }
                    {loading === true &&
                      <p class="loading-bar" id="menuRefreshLoading" >
                        <span ></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                      </p>}

                    <div class="wallet-detail" id="multiBalancePop">
                      <div class="wallet-detail-group">
                        <dl class="wallet-detail-content">
                          <dt >Main Balance</dt>
                          <dd class="wallet-balance-num"> <span class="badge-currency" id="currency">USD</span><span id="mainBalance">0.00</span></dd>
                          <dd class="wallet-exposure">Exposure <span id="mainExposure">0.00</span></dd>
                        </dl>
                      </div>
                      <div id="walletContent" class="wallet-detail-group"><dl id="tempDl" class="wallet-detail-content">
                        <dt id="vendorTitle_3">BPoker Balance</dt>
                        <dd class="wallet-balance-num"> <span class="badge-currency" id="vendorCurrency_3">PBU</span><span id="vendorBalance_3">0</span></dd>
                        <dd class="wallet-recall"><button class="btn-recall" id="recall_3" >Recall</button></dd>
                      </dl><dl id="recallAllDl" class="wallet-detail-content">
                          <dd class="align-R"><button class="btn-recall" id="recallAll" >Recall All</button></dd>
                        </dl></div>
                      <div class="btn-box">
                        <button class="btn" >Close</button>
                      </div>
                    </div>
                  </a>
                  {/*   {loading === true && <li id="menuRefreshIcon" style={{ marginTop:'8px'}}><img className="refresh-bar" src={Refresh} alt="refresh"/></li>}*/}
                  <a id="menuRefresh" class="a-refresh" style={{ background: '#493f57' }} title="Refresh Main Wallet" onClick={handleRefresh}><img src={Transparent} /></a>
                </li>
                {/* End*/}
                {/*     {loading === false && <li id="accountCredit" >
                Main
                <strong >&nbsp;: {balance} &nbsp;</strong>Exposure<strong >&nbsp;:&nbsp;</strong>

                <strong  style={{cursor:' pointer'}} className="red" >{exposure}</strong>
              </li>}
              {loading === true && <li id="menuRefreshIcon" style={{ marginTop:'8px'}}><img className="refresh-bar" src={Refresh} alt="refresh"/></li>}
              <li className="head-refresh"><a     id="Refresh" onClick={handleRefresh}  style={{cursor:'pointer'}}>Refresh</a></li>
                  */}
                <li className="account" style={{ paddingRight: ' 5px' }}>
                  <a id="accountPopup" style={{ cursor: 'pointer' }} onClick={dsClick}>My Account</a>

                  <ul ref={dropdownRef}
                    className={`asdf ${dropdownopen ? "active" : "inactive"}`} id="account_pop" >
                    <li >
                      <h4 >
                        {userid}
                        { }  <span className="gmt" title="Time Zone">GMT+5:30</span>
                      </h4>

                    </li>
                    <li ><a
                      href="/exchange/play/myprofile"
                      target="_blank"
                    ><i aria-hidden="true" style={{ marginTop: ' 2px' }}></i>&nbsp;My Profile</a></li>
                    <li ><a href="/exchange/play/balance" target="_blank"><i aria-hidden="true" style={{ marginTop: ' 2px' }}></i>&nbsp;Balance Overview</a></li>
                    <li ><a href="/exchange/play/AccountStatement" target="_blank"><i aria-hidden="true" style={{ marginTop: ' 2px' }}></i>&nbsp;Account Statement</a></li>
                    <li ><a href="/exchange/play/mybets" target="_blank"><i aria-hidden="true" style={{ marginTop: ' 2px' }}></i>&nbsp;My Bets</a></li>
                    <li ><a href="/exchange/play/bethistory" target="_blank"><i aria-hidden="true" style={{ marginTop: ' 2px' }}></i>&nbsp;Bets History</a></li>
                    <li ><a href="/exchange/play/ProfitLoss" target="_blank"><i aria-hidden="true" style={{ marginTop: ' 2px' }}></i>&nbsp;Profit &amp; Loss</a></li>
                    <li ><a href="/exchange/play/activitylog" target="_blank"><i aria-hidden="true" style={{ marginTop: ' 2px' }}></i>&nbsp;Activity Log</a></li>



                    <li onClick={handleLogout} className="logout"><a href="" id="logout">LOGOUT<img src={Transparent} alt="logout" /></a></li>
                  </ul>

                </li>
              </ul>}


            </div>


            <div className="navbar-content">
              <div className="main-content">

                <ul id="tabMenu" className="menu">
                  <li  ><a href="/exchange/play/home" className={`${(tabMenu === 1) ? "select" : "null"}`} >Home</a></li>
                  <li ><a href="/exchange/play/inplay" className={`${(tabMenu === 2) ? "select" : "null"}`} >In-Play</a></li>
                  <li ><a href="/exchange/play/multimarket" className={`${(tabMenu === 3) ? "select" : "null"}`} >Multi Markets</a></li>
                  <li ><a href="/exchange/play/cricket" className={`${(tabMenu === 4) ? "select" : "null"}`} ><span id="tagLive" class="mob-live-number">
                    <strong></strong>
                    <span  >{countCricket}</span>
                  </span >Cricket</a></li>
                  <li ><a href="/exchange/play/soccer" className={`${(tabMenu === 5) ? "select" : "null"}`} ><span id="tagLive" class="mob-live-number">
                    <strong></strong>
                    <span >{countSoccer}</span>
                  </span   >Soccer</a></li>
                  <li ><a href="/exchange/play/tennis" className={`${(tabMenu === 6) ? "select" : "null"}`} ><span id="tagLive" class="mob-live-number">
                    <strong></strong>
                    <span >{countTennis}</span>
                  </span>Tennis</a></li>

                  <li style={{ display: "none" }}><a href='/exchange/play/basketball' className={`${(tabMenu === 17) ? "select" : "null"}`}><span id="tagLive" class="mob-live-number">
                    <strong></strong>
                    <span >{countBasketball}</span>
                  </span   >BasketBall </a></li>
                  <li style={{ display: "none" }}><a href="/exchange/play/IplWinner" className={`${(tabMenu === 30) ? "select" : "null"}`} >IPL Winner</a></li>

                  {/* <li class="dark_menu-li"><a href="/"  id="casinoLoginBtn" class="casino tag-new" style={{ color: ' #fff' }}>Casino</a></li> */}
                  <li style={{ display: "none" }}><a href="/exchange/play/election" className={`${(tabMenu === 31) ? "select" : "null"}`} ><span id="tagLive" class="mob-live-number">
                    <strong></strong>
                    <span >{1}</span>
                  </span>Election</a></li>


                  <li style={{ display: "none" }} ><a>Horse Racing</a></li>

                  {/* <li class="dark_menu-li"><a href="/"  id="casinoLoginBtn" class="casino tag-new" style={{ color: ' #fff' }}>Casino</a></li> */}
                  <li ><a   >Result</a></li>
                  <li style={{ display: "none" }} ><a >Binary </a></li>
                  <li style={{ display: "none" }}><a >Boxing </a></li>
                  <li style={{ display: "none" }} ><a >Kabaddi </a></li>
                  <li style={{ display: "none" }}><a >GreyHound Racing </a></li>
                  <li class="dark_menu-li"><a href="/" id="casinoLoginBtn" class="casino tag-new" style={{ color: ' #fff' }}>Casino</a></li>
                  {/* <li class="dark_menu-li"><Link to = '/home'  id="casinoLoginBtn" class="casino tag-new" style={{color:' #fff'}}>Casino</Link></li>
          <li class="dark_menu-li"><Link to ='/slots' id="casinoBetgameLoginBtn" class="bet-game tag-new" style={{color:' #fff'}}>Slots</Link></li> */}


                </ul>

                <ul className="setting-tab">
                  {tabMenu !== 7 && tabMenu !== 8 && tabMenu !== 9 && tabMenu !== 10 && tabMenu !== 11 && tabMenu !== 12 && tabMenu !== 13 && tabMenu !== 25 &&
                    <li className="time_zone" style={{ display: 'block' }}><span > Time Zone :</span> GMT+5:30</li>}
                  {tabMenu !== 7 && tabMenu !== 8 && tabMenu !== 9 && tabMenu !== 10 && tabMenu !== 11 && tabMenu !== 12 && tabMenu !== 13 && tabMenu !== 25 &&
                    <li onClick={handleOnclick}><a id="oneClickSetting" className={`one_click ${(oneClick === true) ? "select" : "null"}`} style={{ cursor: ' pointer' }}><img src={Transparent} alt="One_Click" />One Click Bet</a></li>}

                  <li ><a id="login-trigger" onClick={handlesetting} className="setting" style={{ cursor: ' pointer' }}>Setting <img src={Transparent} alt="login-trigger" /></a></li>
                </ul>





                {isActive &&
                  <div id="set_pop" ref={dropdownRef1}
                    className={`slip_set-pop ${isActive ? "active" : "inactive"}`}>
                    <Settings userid={userid} utoken={tt} handlesetting={handlesetting} />
                  </div>}

              </div>
            </div>
          </div>

          {tabMenu !== 7 && tabMenu !== 8 && tabMenu !== 9 && tabMenu !== 10 && tabMenu !== 11 && tabMenu !== 12 && tabMenu !== 13 && tabMenu !== 25 &&
            <Content setPassword={setPassword} setId={setId} password={password} handleClose={handleClose} open={open} updateBalance={updateBalance} handleOpen={handleOpen} EventT={props.match.params.eventT} EventId={eventId} MarketId={marketId} tabmenu={tabMenu} oneclick={oneClick} userid={userid} utoken={tt} changeTab={changeTab} isLoggedIn={isLoggedIn} />
          }
          {tabMenu > 0 && isLoggedIn === true &&
            <div className="main_wrap">
              {tabMenu === 7 && (
                <Myprofile userid={userid} handlepassmodel={handlepassmodel} />
              )}
              {tabMenu === 8 && (
                <Balanceoverview userid={userid} utoken={tt} balance={balance} handlepassmodel={handlepassmodel} />
              )}
              {tabMenu === 9 && (
                <AccountStatement
                  userid={userid}
                  utoken={tt}
                  handlepassmodel={handlepassmodel}
                />
              )}
              {tabMenu === 10 && <Mybets userid={userid} utoken={tt} handlepassmodel={handlepassmodel} />}
              {tabMenu === 11 && (
                <Bethistory userid={userid} utoken={tt} handlepassmodel={handlepassmodel} />
              )}
              {tabMenu === 12 && (
                <ProfitLoss userid={userid} utoken={tt} handlepassmodel={handlepassmodel} />
              )}
              {tabMenu === 25 && (
                <CasinoReport userid={userid} utoken={tt} handlepassmodel={handlepassmodel} />
              )}
              {tabMenu === 13 && <ActivityLog userid={userid} handlepassmodel={handlepassmodel} />}
            </div>

          }


        </React.Fragment>
      )}
      {(firstlogin == 1 || firstlogin == 2) &&

        <FirsttimeLogin password={password} firstlogin={firstlogin} userid={userid} utoken={tt} />
      }
    </React.Fragment>

  )
}
